var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiSmileFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.392,
    height: 39.392,
    viewBox: "0 0 39.392 39.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#555;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.7,39.392A19.7,19.7,0,1,0,0,19.7,19.7,19.7,0,0,0,19.7,39.392ZM17.234,16c0,2.039-1.1,3.693-2.462,3.693S12.31,18.041,12.31,16s1.1-3.693,2.462-3.693S17.234,13.964,17.234,16ZM10.55,23.554A1.231,1.231,0,0,1,12.231,24a8.621,8.621,0,0,0,14.929,0,1.231,1.231,0,1,1,2.132,1.231,11.083,11.083,0,0,1-19.194,0,1.231,1.231,0,0,1,.451-1.682ZM24.62,19.7c-1.359,0-2.462-1.654-2.462-3.693s1.1-3.693,2.462-3.693S27.082,13.964,27.082,16,25.979,19.7,24.62,19.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmileFill);
export default __webpack_public_path__ + "static/media/emoji-smile-fill.25f88e8cefa4777998d96237d352fc16.svg";
export { ForwardRef as ReactComponent };